import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

import { Button } from '@/components/ui/button';
import { Typography } from '@/components/ui/typography';

export function Agreement() {
  return (
    <Typography variant="small1" className="!text-fx-neutral-400 text-center">
      <FormattedMessage
        defaultMessage='By clicking on the button to "Post", I agree to Fountain&apos;s {termsLink}, {msaLink} and {privacyLink}.'
        description="Agreement text"
        values={{
          termsLink: (
            <Button variant="text" asChild>
              <Link to="https://www.fountain.com/tos.html" target="_blank">
                <FormattedMessage
                  defaultMessage="Terms of Service"
                  description="Terms of Service link"
                />
              </Link>
            </Button>
          ),
          msaLink: (
            <Button variant="text" asChild>
              <Link
                to="https://privacy.fountain.com/policies/en/?name=master-subscription-agreement"
                target="_blank"
              >
                <FormattedMessage
                  defaultMessage="Master Subscription Agreement"
                  description="Master Subscription Agreement link"
                />
              </Link>
            </Button>
          ),
          privacyLink: (
            <Button variant="text" asChild>
              <Link to="https://www.fountain.com/privacy.html" target="_blank">
                <FormattedMessage
                  defaultMessage="Privacy Policy"
                  description="Privacy Policy link"
                />
              </Link>
            </Button>
          ),
        }}
      />
    </Typography>
  );
}
